import { get, post } from "./request";
import { buildApiUrl, API_CONFIG } from "./config";
import type { ApiResponse } from "./types";

/** 频道项，与接口返回一致 */
export interface ShareChannelItem {
  id: number;
  name: string;
}

/** 提交分享参数 */
export interface SubmitShareParams {
  game_id: string;
  role_id: string;
  server_id: string;
  channel_id: string;
  tid: number;
  thread_title: string;
  thread_url: string;
  description: string;
  language: string;
}

export const shareApi = {
  /**
   * 获取分享频道列表
   */
  getChannels: (): Promise<ApiResponse<ShareChannelItem[]>> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.SHARE_THREAD,
      API_CONFIG.ACTIONS.GET_CHANNELS
    );
    return get<ApiResponse<ShareChannelItem[]>>(url);
  },

  /**
   * 提交分享（需要登录态）
   */
  submitShare: (params: SubmitShareParams): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.SHARE_THREAD,
      API_CONFIG.ACTIONS.SUBMIT_SHARE
    );
    return post<ApiResponse>(url, params);
  },
};
